import React, { useEffect } from 'react';

import {
    LandingPage,
    Home,
    Settings,
    NotFound,
    Logout,
    NotAuthorised,
    Cookies,
    TandC,
    Privacy,
    Accessibility,
    LoginCallback,
    History,
} from './pages';

import ProtectedRedirect from './components/auth/ProtectedRedirect';
import { AppRoutes } from './Constants';
import Layout from './components/layout/Layout';
import UserInfoWrapper from './helpers/UserInfoWrapper';
import i18nSetup from './locale/i18nSetup';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import SubmissionFormWizard from 'pages/SubmissionFormWizard/SubmissionFormWizard';

const App = () => {
    i18nSetup();

    const colourTheme: 'orange' | 'pink' | 'red' | 'black' = 'pink';

    useEffect(() => {
        document.body.setAttribute('data-theme', colourTheme);
        return () => document.body.removeAttribute('data-theme');
    }, [colourTheme]);

    const router = createBrowserRouter([
        {
            path: AppRoutes.LandingPage,
            element: <LandingPage />,
            index: true,
        },
        {
            // Routes accessible to authenticated users
            element: <Layout />,
            children: [
                {
                    element: (
                        <ProtectedRedirect>
                            <UserInfoWrapper />
                        </ProtectedRedirect>
                    ),
                    children: [
                        {
                            path: AppRoutes.HomePage,
                            element: <Home />,
                        },
                        {
                            path: AppRoutes.SettingsPage,
                            element: <Settings />,
                        },
                        {
                            path: AppRoutes.CreateDeclaration,
                            element: <SubmissionFormWizard />,
                        },
                        {
                            path: AppRoutes.EditDeclaration,
                            element: <SubmissionFormWizard />,
                        },
                        {
                            path: AppRoutes.History,
                            element: <History />,
                        },
                    ],
                },
                {
                    path: AppRoutes.LogoutPage,
                    element: <Logout />,
                },
                {
                    path: '/login/callback',
                    element: <LoginCallback />,
                },
                {
                    path: '/403',
                    element: <NotAuthorised />,
                },
                {
                    path: '*',
                    element: <NotFound />,
                },
            ],
        },
    ]);

    return (
        <div className="d-flex flex-column h-100 min-vh-100 overflow-hidden">
            <RouterProvider router={router} />
        </div>
    );
};

export default App;
